import React, { useContext } from 'react';
import { Data } from './metadata/Data';
import { Expression } from './metadata/Expression';
import { GlobalStateContext } from '../context/GlobalStateProvider';
import { ModelContext } from './metadata/ModelSource';
import { formatMoneyAmount } from '../utils/formatUtils';
import { onSubmitAgent } from '../api/applicationAPI';
import { EmailSVG, PersonSVG } from '../components/svg';
import { FormContext } from './metadata/MDForm';

export const SummaryBar = ({ content, onSubmitEmail }) => {
  const { isDesktop, changeSummaryLayout, hideNavLabels } = useContext(
    GlobalStateContext
  );

  const { getValueByAttr } = useContext(FormContext);

  const styles = {
    container: {
      display: 'flex',
      justifyContent: changeSummaryLayout ? 'space-between' : 'center',
      flexDirection: changeSummaryLayout ? 'row' : 'column',
    },
  };

  const Sections = () => {
    return content.map(({ path, attr, dataType, label, ...props }, index) => {
      if (path) {
        return (
          <div style={styles.container}>
            <Expression value={label} style={{ fontSize: '14px' }} />
            <Data path={path} dataType={dataType} {...props} />
          </div>
        );
      }

      if (dataType === 'Address') {
        if (!isDesktop) return null;
        if (Array.isArray(attr)) {
          const street = attr[0];
          const value = getValueByAttr(street);
          const addrObj = (undefined !== value && (undefined !== value.Addr1 || undefined !== value.addr1))  ?
              (
                  (value.Addr1 ||value.addr1) + ' '+
                  (value.City|| value.city) + ', '+
                  (value.StateProvCd || value.stateProvCd) + ', ' +
                  (value.PostalCode || value.postalCode)
              )
              : undefined;
          return (
              <div style={styles.container}>
                <Expression value={label} style={{ fontSize: '14px', paddingTop: '15px' }} />
                {!addrObj ? (
                    <p style={{ fontSize: '24px' }}>{''}</p>
                ) : (<p style={{ fontSize: '16px' }}>{addrObj}</p>)
                }
              </div>
          );
        }
        return null;
      }

      if (dataType === 'Money') {
        const { data: model } = useContext(ModelContext);
        const total =
          parseFloat(model.basicPolicy.writtenPremiumAmt) +
          parseFloat(model.basicPolicy.writtenFeeAmt);

        const value = isNaN(total) ? '$0.00' : formatMoneyAmount(total);

        return (
          <div style={styles.container}>
            <Expression value={label} style={{ fontSize: '14px' }} />
            <Expression
              value={value}
              style={{ fontSize: hideNavLabels ? '16px' : '' }}
            />
          </div>
        );
      }

      if (attr) {
        return (
          <div style={styles.container}>
            <Expression value={label} style={{ fontSize: '14px' }} />
            <Data attr={attr} dataType={dataType} {...props} />
          </div>
        );
      }

      return null;
    });
  };
  const model = useContext(ModelContext);
  const resourceId = model.data.systemId;
  const applicationNumber = model.data.applicationNumber;
  return (
    <div
      className={'summary-bar'}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignContent: 'center',
        flexDirection: changeSummaryLayout ? 'column' : 'row',
      }}
    >
      <Sections />
      {!isDesktop && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '80px',
            padding: changeSummaryLayout ? '5px 5px' : '',
            alignSelf: changeSummaryLayout ? 'flex-end' : '',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
            }}
            onClick={onSubmitEmail}
            className="summary-buttons"
          >
            <EmailSVG height={'16'} width={'16'} color={'#ffffff'} />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
            }}
            onClick={() => onSubmitAgent(resourceId, applicationNumber)}
            className="summary-buttons"
          >
            <PersonSVG color={'#ffffff'} />
          </div>
        </div>
      )}
    </div>
  );
};
